import { Button, Stack, Text } from '@chakra-ui/react';
import type { OrganizationPaidCheckoutOperation } from '@fluenceur/types';
import { NoticePanel } from '@fluenceur/ui';
import { buttonRecipe } from '@fluenceur/theme';
import { formatPlanPrice } from '@/libs/utils/format-plan-price';
import { useTranslation } from 'react-i18next';

/** Receipts explain waiting; only a canonical context can change access. */
export function PaidCheckoutNotice({
  operation,
  onCheck,
  onResume,
  busy = false,
  canResume = false,
}: {
  operation?: OrganizationPaidCheckoutOperation | null;
  onCheck: () => void;
  onResume?: () => void;
  busy?: boolean;
  canResume?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <NoticePanel
      tone="info"
      title={t('planChoice.paid.pendingTitle')}
      actions={
        <Stack direction="row" flexWrap="wrap">
          <Button
            variant="outline"
            css={buttonRecipe.variants?.variant?.secondary}
            disabled={busy}
            onClick={onCheck}
          >
            {t('onboarding.billing.checkCta')}
          </Button>
          {onResume && ['open', 'expired'].includes(operation?.status ?? '') && (
            <Button disabled={busy || !canResume} onClick={onResume}>
              {t('planChoice.paid.resumeCta')}
            </Button>
          )}
        </Stack>
      }
    >
      {t('planChoice.paid.pendingBody')}
      {operation && (
        <Text mt={2}>
          {t('planChoice.upgrade', {
            plan: t(
              `pricing.plan.${operation.planId === 'growth_monthly' ? 'growth' : 'essential'}.name`
            ),
            price: formatPlanPrice(
              operation.unitAmount / 100,
              operation.currency,
              t('common.locale')
            ),
          })}
        </Text>
      )}
    </NoticePanel>
  );
}
